import axios from 'axios';
import { socketIdReady } from 'larasnap/echo';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

socketIdReady.then(id => {
    axios.defaults.headers.common['X-Socket-ID'] = id;
});

const token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else if (process.env.NODE_ENV !== 'test') {
    console.error(
        'CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token',
    );
}

export default axios;
